import { activity } from 'actions/activity'
import { useCallback } from 'react'
import { useLocation } from 'react-router-dom'

// TODO: better to revalidate query in RTK
export function useRefetch() {
	const { pathname } = useLocation()

	return useCallback(() => {
		if (pathname === '/activities-queue') {
			activity.getActivities()
		}
	}, [pathname])
}
